module.exports = __webpack_public_path__ + "static/media/haaga-helia-logo-en.73773516.png";